<template>
  <div class="report-content" v-if="showReportContent" ref="mainReportContent">
    <div class="panel-title">Please describe the report content.</div>
    <textarea type="text" class="input-area" v-model="reportcontent"></textarea>
    <div class="input-desc"><span class="curTextCount" v-text="textCount"></span>/300</div>
    <div class="panel-title">upload image <span class="title-desc">(Up to four)</span></div>
    <div class="img-add-panel">
      <div :key="index" class="img-item-panel" v-for="(item,index) in imgList">
        <div class="add-btn" v-if="item.isAdd" @click="addImg()"></div>
        <div class="close" v-if="!item.isAdd" @click="deleteImg(index)"></div>
        <img :src="item.url" v-if="!item.isAdd">
      </div>
    </div>
    <div class="submit-action" @click="doSubmit">Submit</div>
  </div>
</template>

<script>
import {isnull} from "../../utils/tools";

export default {
  name: "reportdialog",
  props: {
    'acc': {
      default: 0
    },
    'showReportContent':{
      type:Boolean,
      default: false
    }
  },
  data() {
    return {
      imgList: [{
        isAdd: true,
        url: ''
      }],
      textCount: 0,
      reportcontent: '',
    }
  },
  mounted() {
    document.addEventListener("click", this.bodyCloseReportContent);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.bodyCloseReportContent);
  },
  methods: {
    hideDialog() {
      this.$emit('hideReportContent')
    },
    doSubmit() {
      if (isnull(this.acc)) {
        return
      }
    },
    deleteImg(index) {
      this.imgList.splice(index, 1)
    },
    bodyCloseReportContent(e) {
      let self = this;
      if (this.$refs.mainReportContent && !this.$refs.mainReportContent.contains(e.target)) {
        self.hideDialog();
      }
    },
  }
}
</script>

<style scoped lang="less">
@import "~styles/index.less";
@import "~styles/variable.less";

.report-content {
  background: #FFFFFF;
  .w(750);
  .minh(864);
  position: fixed;
  bottom: 0;
  text-align: left;
  .b-radius(24, 24, 0, 0);
  font-family: Gilroy-Medium;

  .panel-title {
    .fs(28);
    font-family: Gilroy-Bold;
    color: #080808;
    .lh(34);
    .ml(29);
    .mt(24);
    .mb(20);

    .title-desc {
      color: #B2B5B8;
    }
  }

  .input-area {
    .padding(20, 20);
    .w(650);
    .h(220);
    background: #F3F5F7;
    .b-radius(12);
    .ml(29);
    border: none;
  }

  .input-desc {
    .w(719);
    text-align: right;
    .fs(28);
    font-weight: 600;
    color: #C1C3C7;
    .lh(40);
    .mt(6)
  }

  .img-add-panel {
    .w(690);
    .minh(170);
    .mt(3);
    .ml(30);
    .mr(17);

    .img-item-panel {
      .w(172);
      .h(172);
      display: inline-block;

      img {
        .mt(12);
        .w(160);
        .h(160);
        background: #F3F5F7;
        .b-radius(12);
        cursor: pointer;
      }

      .add-btn {
        .mt(12);
        .w(160);
        .h(160);
        background: url(../../assets/imgs/add-img-icn.png) no-repeat;
        background-size: contain;
        cursor: pointer;
      }

      .close {
        .w(40);
        .h(40);
        background: url(../../assets/imgs/close-add-img.png) no-repeat;
        background-size: contain;
        position: absolute;
        .ml(132);
        z-index: 2;
      }
    }
  }

  .submit-action {
    .w(654);
    .h(120);
    .mt(145);
    .mb(30);
    background: linear-gradient(270deg, #FB5F7C 0%, #FF32A1 100%);
    .b-radius(60);
    color: #FFFFFF;
    .fs(40);
    font-weight: 600;
    color: #FFFFFF;
    text-align: center;

    .lh(120);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/widget/reportcontentdialog.vue